import { AVAILABLE_BRAND_FEATURES } from '@kouto/types';
import { isFeatureActive } from 'utils/featureFlag';

const useIsHyattLMSEnabledFlag = () => {
  const hyattLMSEnabled = isFeatureActive(
    AVAILABLE_BRAND_FEATURES.ENABLE_HYATT_LMS,
  );
  return hyattLMSEnabled;
};

export default useIsHyattLMSEnabledFlag;
